const SEO = [
	{
		page: "home",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: [
			"Front-end developer",
			"UX",
			"UI",
			"Designer",
			"Full stack",
			"Ian Kleinfeld",
		],
	},

	{
		page: "about",
		description:
			"Ian Kleinfeld, Software Developer, Front End Engineer, Full Stack, UX, UI, with a deep UX, UI, and Design background.",
		keywords: [
			"Front-end developer",
			"UX",
			"UI",
			"Designer",
			"Full stack",
			"Ian Kleinfeld",
		],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: [
			"Front-end developer",
			"UX",
			"UI",
			"Designer",
			"Full stack",
			"Ian Kleinfeld",
		],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: [
			"Front-end developer",
			"UX",
			"UI",
			"Designer",
			"Full stack",
			"Ian Kleinfeld",
		],
	},

	{
		page: "contact",
		description:
			"I can't even remember how many projects I've worked on over the years for private clients or companies or just for fun. But I always learn a lot of new skills and I love it. Each project is a chance to learn something new about technology, design, people, business, and more. Over the years, I've learned everything from the most basic HTML and CSS to arcane and nearly archaic languages like Freemarker, to battleship size CMSs like Khoros Community or Adobe AEM, to cutting edge web dev modern stacks like React, and Vue, with or without Typescript.",
		keywords: [
			"Front-end developer",
			"UX",
			"UI",
			"Designer",
			"Full stack",
			"Ian Kleinfeld",
		],
	},
	{
		page: "animations",
		description:
			"These are a series of Agile metrics explainer videos that I did for rally software. Each one explains a different aspect of Agile metrics, how it works and why it's important. Each one was written, developed invoiced over by me.",
		keywords: [
			"Front-end developer",
			"UX",
			"UI",
			"Designer",
			"Animation",
			"Full stack",
			"Ian Kleinfeld",
		],
	},
	{
		page: "getstarted",
		description:
			"Get started with a free, no-obiligation consultation or quote today.",
		keywords: [
			"Web design",
			"Web development",
			"Website design",
			"Website development",
			"Website",
			"Web designer",
			"Web developer",
			"Web company",
			"Build website",
			"Get started",
			"Consultation",
			"Website Quote",
			"Ian Kleinfeld",
			"Front-end developer",
			"UX",
			"UI",
			"GraphicDesigner",
			"Full stack developer",
			"Web development company",
			"Web development agency",
			"Front-end Developer",
			"Fast website",
			"Website builder",
			"Website professional",
			"Website development company",
			"Website development agency",
			"Website development professional",
		],
	},
	{
		page: "showimage",
		description:
			"Image of a project I worked on that is either a poster or a website that no longer exists",
		keywords: [
			"design",
			"development",
			"graphic design",
			"UX",
			"UI",
			"Designer",
		],
	},
	{
		page: "coaroauth",
		description: "Cisco OAuth Registration",
		keywords: [
			"COAR",
			"Cisco",
			"OAuth",
			"Registration",
			"COAR Project",
			"portfolio",
		],
	},
];

export default SEO;
